export default __webpack_public_path__ + "static/media/logo-databit.54c2d555.png";